module.exports = __webpack_public_path__ + "img/AFMS-ProfilePic.ea07db10.png";